import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

import Button from "../button/index.js";
import Columns from "../columns/index.js";
import Forms from "../forms/index.js";

import styles from "./styles.module.scss";

const Tabs = React.memo(({ control, responsive, tabs, type }) => {
  const [activeTab, setActiveTab] = useState(0);

  const classNameByType = {
    dropdown: styles.tabsDropdown,
    tabs: styles.tabsButtons
  };

  const handleDropdownChange = useCallback(
    (event) => {
      const index = tabs.findIndex((tab) => tab.label === event.target.value);
      setActiveTab(index);
    },
    [tabs]
  );

  return (
    <Columns numberOfColumns={1} gap={"lg"}>
      <Columns
        className={classNameByType[type]}
        numberOfColumns={
          (type === "tabs" ? tabs.length : 1) + (control ? 1 : 0)
        }
        responsive={responsive}
        verticalAlignment={"bottom"}
      >
        {type === "dropdown" && (
          <Forms
            type="select"
            name="tabs-dropdown"
            onChange={handleDropdownChange}
            options={tabs}
            value={tabs[activeTab].label}
          />
        )}
        {type === "tabs" && (
          <>
            {tabs.map((tab, index) => {
              return (
                <Button
                  className={`${styles.tabsButton} ${
                    activeTab === index ? styles.tabsButtonActive : ""
                  }`}
                  key={tab.label}
                  label={tab.label}
                  onClick={() => setActiveTab(index)}
                />
              );
            })}
          </>
        )}
        {control}
      </Columns>
      <div className={styles.content}>{tabs[activeTab].content}</div>
    </Columns>
  );
});

Tabs.propTypes = {
  control: PropTypes.node,
  responsive: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired
    })
  ),
  type: PropTypes.oneOf(["tabs", "dropdown"])
};

Tabs.defaultProps = {
  control: null,
  responsive: true,
  tabs: [],
  type: "tabs"
};

export default Tabs;
